var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLines = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1479,
    height: 941,
    viewBox: "0 0 1479 941",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_371_72500)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1285.88,
    y1: 940.766,
    x2: 1285.88,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1225.11,
    y1: 940.766,
    x2: 1225.11,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1164.35,
    y1: 940.766,
    x2: 1164.35,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1103.59,
    y1: 940.766,
    x2: 1103.59,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1042.82,
    y1: 940.766,
    x2: 1042.82,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 982.057,
    y1: 940.766,
    x2: 982.057,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 921.293,
    y1: 940.766,
    x2: 921.293,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860.528,
    y1: 940.766,
    x2: 860.529,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 799.765,
    y1: 940.766,
    x2: 799.765,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 739,
    y1: 940.766,
    x2: 739,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 678.235,
    y1: 940.766,
    x2: 678.236,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.472,
    y1: 940.766,
    x2: 617.472,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.707,
    y1: 940.766,
    x2: 556.707,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.943,
    y1: 940.766,
    x2: 495.944,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.179,
    y1: 940.766,
    x2: 435.179,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.415,
    y1: 940.766,
    x2: 374.415,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.651,
    y1: 940.766,
    x2: 313.651,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.887,
    y1: 940.766,
    x2: 252.887,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.122,
    y1: 940.766,
    x2: 192.122,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.359,
    y1: 940.766,
    x2: 131.359,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.5939,
    y1: 940.766,
    x2: 70.594,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.8302,
    y1: 940.766,
    x2: 9.83032,
    y2: 4.99763,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 940.266,
    x2: 1479,
    y2: 940.266,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 907.997,
    x2: 1479,
    y2: 907.998,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 875.73,
    x2: 1479,
    y2: 875.73,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 843.462,
    x2: 1479,
    y2: 843.462,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 811.195,
    x2: 1479,
    y2: 811.195,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 778.926,
    x2: 1479,
    y2: 778.926,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 746.658,
    x2: 1479,
    y2: 746.659,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 714.391,
    x2: 1479,
    y2: 714.391,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 682.122,
    x2: 1479,
    y2: 682.123,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 649.855,
    x2: 1479,
    y2: 649.855,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 617.587,
    x2: 1479,
    y2: 617.587,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 585.32,
    x2: 1479,
    y2: 585.32,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 553.051,
    x2: 1479,
    y2: 553.051,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 520.783,
    x2: 1479,
    y2: 520.784,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 488.516,
    x2: 1479,
    y2: 488.516,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 456.247,
    x2: 1479,
    y2: 456.248,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 423.98,
    x2: 1479,
    y2: 423.98,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 391.712,
    x2: 1479,
    y2: 391.712,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 359.444,
    x2: 1479,
    y2: 359.444,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 327.176,
    x2: 1479,
    y2: 327.176,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 294.908,
    x2: 1479,
    y2: 294.909,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 262.641,
    x2: 1479,
    y2: 262.641,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 230.372,
    x2: 1479,
    y2: 230.373,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 198.105,
    x2: 1479,
    y2: 198.105,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 165.837,
    x2: 1479,
    y2: 165.837,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 133.569,
    x2: 1479,
    y2: 133.569,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 101.301,
    x2: 1479,
    y2: 101.301,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 69.0335,
    x2: 1479,
    y2: 69.0337,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 36.7649,
    x2: 1479,
    y2: 36.7652,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 4.49732,
    x2: 1479,
    y2: 4.49758,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 0.000251369,
    width: 1479,
    height: 941,
    fill: "url(#paint0_radial_371_72500)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_371_72500",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(740 563.5) rotate(90) scale(377.5 582.929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_72500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1479,
    height: 941,
    fill: "white",
    transform: "translate(1479 941) rotate(-180)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLines);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lines.0dc35c2d8f2348e45cf3b3d0de102f7d.svg";